<template>
    <div class="rel z:1000">
        <div class="d:none d:block@sm">
            <a
                class="
                    float-btn cursor:pointer
                    {w:86;h:86;bg:url(image/index/btn_forum.svg);bottom:30;right:20;block;box-shadow:0|12|15|0|#06C75533;r:100%}
                    {mb:0!}@lg
                    transform-origin:center|center
                    transform:scale(0.9069)
                    {transform:scale(1)}:hover
                "
                :class="classList"
                @click="click"
            ></a>
        </div>
        <div class="d:block d:none@sm">
            <a
                class="
                    float-btn cursor:pointer
                    {w:48;h:48;bg:url(image/index/btn_forum_s.svg);bottom:16;right:16;block}
                    transform-origin:center|center
                    {transform:scale(1.15)}:hover
                "
                :class="classList"
                @click="click"
            ></a>
        </div>
        <div class="abs {top:0}@lg d:none@<sm" :class="`top:${space}`" ref="anchor"></div>
    </div>
</template>

<script setup>
    const { useElementVisibility } = VueUse;

    const anchor = ref();
    const footer = useElementVisibility(anchor);
    const marq = ToggleStore().toggler("marq");

    const classList = computed(() => footer.value ? "abs" : `fixed mb:${space.value}`);
    const space = computed(() => marq.isOpen() ? 114 : 66);

    const props = defineProps({
        href: { required: true, type: String }
    });

    const click = () => {
        window.open(props.href, "_blank");
    };
</script>
